export default __webpack_public_path__ + "static/media/covax-branding-image.70de5d7d.svg";